import { getInternalUrl, setExternalUrl } from '@utils';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const WrapInLink = forwardRef(
  ({ href, title, className, attributes, children, target }, ref) => {
    const internalUrl = getInternalUrl(href);
    if (internalUrl) {
      return (
        <Link
          ref={ref}
          href={internalUrl}
          className={className}
          title={title}
          itemProp="url"
          target={target}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...attributes}
        >
          {children}
        </Link>
      );
    }

    return (
      <a
        ref={ref}
        href={setExternalUrl(href)}
        target="_blank"
        rel="noopener"
        itemProp="url"
        className={className}
        title={title}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...attributes}
      >
        {children}
      </a>
    );
  }
);

WrapInLink.displayName = 'WrapInLink';

WrapInLink.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  target: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  attributes: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default WrapInLink;
